/* global axios */
import ApiClient from './ApiClient';

class AccountTemplatesAPI extends ApiClient {
  constructor() {
    super('reseller/account_templates', { accountScoped: true });
  }

  catalog() {
    return axios.get(`${this.url}/catalog`);
  }

  apply(payload) {
    return axios.post(this.applicationsUrl, payload);
  }

  application(id) {
    return axios.get(`${this.applicationsUrl}/${id}`);
  }

  retryFailed(id) {
    return axios.post(`${this.applicationsUrl}/${id}/retry_failed`);
  }

  get applicationsUrl() {
    return this.url.replace('/account_templates', '/template_applications');
  }
}

export default new AccountTemplatesAPI();
